import React, { useMemo } from 'react';
import {ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell
} from 'recharts';


// --- Sub-Component: Horizontal Bar Chart ---
export default function HorizontalBarChartReport ({ data }){
    //console.log("HorizontalBarChartReport-data", data);
    return ( <div className="card shadow printable-unit">
                <h3 className="card-label">Comparison of Character Drivers</h3>
                <p className='font-s12 chart-title'>Count of responses per Character Type</p>
                <div className="chart-wrapper-md">
                <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={data} layout="vertical" margin={{ left: 20, right: 20 }}>
                    <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#f1f5f9" />
                    <XAxis type="number" hide />
                    <YAxis 
                        dataKey="subject" 
                        type="category" 
                        width={140} 
                        tick={{ fontSize: 10, fill: '#64748b' }} 
                    />
                    <Tooltip cursor={{ fill: '#f8fafc' }} />
                    <Bar dataKey="A" radius={[0, 4, 4, 0]}>
                        {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                        ))}
                    </Bar>
                    </BarChart>
                </ResponsiveContainer>
                </div>
            </div>
            )
};